import React, { useMemo } from 'react';

import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import professor from 'assets/prof.png';

import { useDomainVerification } from '../../context';

export const Check = () => <Icon icon={faCheck} className="verification-check" />;

const LeftColumn = (props) => {
  const { backEnabled, helperText } = props;
  const { back } = useDomainVerification();

  // Back button only to be rendered on TXT_RECORD
  const backIcon = useMemo(() => (
    backEnabled
      ? <Icon icon={faChevronLeft} className="verification-col-left-chevron" onClick={back} />
      : null
  ), [backEnabled, back]);

  return (
    <div className="verification-col-left">
      <div className="verification-col-left-top">
        <Icon icon={faFacebook} />
        &nbsp;
        Business Settings
      </div>
      { backIcon }
      <div>
        <h1>Facebook Domain Verification Process</h1>
        <div className="verification-col-left-content">{ helperText }</div>
      </div>
    </div>
  );
};

const RightColumn = (props) => {
  const { title, checklist, children } = props;

  const renderedChecklist = useMemo(() => (
    <ul className="verification-col-right-checklist">
      {
        checklist.map(item => (
          <li>
            <Check />
            <span>{item}</span>
          </li>
        ))
      }
    </ul>
  ), [checklist]);

  return (
    <div className="verification-col-right">
      <div className="verification-col-right-contents">
        <h1 className="verification-col-right-title">{ title }</h1>
        <div className="verification-col-right-main-content">
          { renderedChecklist }
          { children }
        </div>
      </div>
      <footer className="verification-col-right-footer">
        <div>
          <span>Need Help?   </span>
          { /* eslint-disable-next-line */}
          <a href="https://www.realgeeks.com/support" target="_blank">Contact Real Geeks Support</a>
        </div>
        <img className="professor" src={professor} alt="Real Geeks Professor" />
      </footer>
    </div>

  );
};

export default function StepContent(props) {
  const {
    title,
    helperText,
    checklist,
    backEnabled = false,
    children,
  } = props;

  return (
    <div className="verification verification-modal-big" data-testid="verification-modal">
      <LeftColumn helperText={helperText} backEnabled={backEnabled} />
      <RightColumn title={title} checklist={checklist}>
        { children }
      </RightColumn>
    </div>
  );
}
